// Видимость коммерции (тарифы, апгрейд, покупка) — ОДНО правило на приложение.
//
// ┌─ Зачем это вообще ────────────────────────────────────────────────────────┐
// │ App Store guideline 3.1.1: цифровая подписка внутри приложения продаётся   │
// │ только через IAP. Наш платёжный контур — YooKassa и PayPal, то есть        │
// │ мимо. Пока IAP не заведён, мобильная сборка обязана не показывать ни       │
// │ тарифов, ни кнопок покупки — иначе ревью заворачивает сборку.              │
// │                                                                           │
// │ Тарифы при этом НЕ отменяются: пользователь получает Pro автовыдачей и     │
// │ видит свой уровень. Скрывается ровно продажа.                              │
// └───────────────────────────────────────────────────────────────────────────┘
//
// Правило живёт здесь, а не в трёх компонентах: второй экземпляр этого условия
// означает поверхность, которую забыли закрыть, — и отказ ревью по одной
// кнопке в подвале.

import type { ModulePlatform } from "./types.js";

/**
 * Ключ флага в `feature_flags_overrides`. Переключается в админке
 * (`/settings/feature-flags`) с обязательной причиной и записью в аудит.
 *
 * Флага нет в таблице ⇒ он выключен ⇒ коммерция в мобильной сборке скрыта.
 * Это осознанный fail-closed: «настройку ещё не завели» и «продавать нельзя»
 * должны совпадать, иначе первый же деплой уедет на ревью с витриной тарифов.
 */
export const COMMERCE_MOBILE_VISIBLE_FLAG = "commerce.mobile_visible";

/**
 * Показывать ли коммерцию.
 *
 * Веб — всегда да: это платёжный канал продукта, и гасить его мобильным
 * ограничением нельзя. Capacitor — только по флагу.
 */
export function resolveCommerceVisible(
	platform: ModulePlatform,
	mobileFlagEnabled: boolean,
): boolean {
	return platform === "capacitor" ? mobileFlagEnabled : true;
}

/**
 * Ответ, когда сервера ещё не слышали: первый запуск, офлайн, протухший
 * снапшот, карта чужого пользователя.
 *
 * Здесь нельзя повторить ошибку класса «fail-open признак безопасности офлайн»:
 * булев из сети без сети не должен превращаться в «разрешено». На вебе
 * неизвестность безопасно трактуется как «показать» (там продажа легальна), на
 * Capacitor — как «скрыть».
 */
export function commerceVisibleFallback(platform: ModulePlatform): boolean {
	return platform !== "capacitor";
}
